import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { buyerMe, buyerLogin, buyerRegister, buyerLogout } from '@/api/auction';
import { logError } from '@/utils/logger';

const BuyerAuthContext = createContext(null);

export function BuyerAuthProvider({ children }) {
  const [buyer, setBuyer] = useState(null);
  const [ready, setReady] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const me = await buyerMe();
      setBuyer(me);
    } catch {
      setBuyer(null);
    } finally {
      setReady(true);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (data) => { const u = await buyerLogin(data); setBuyer(u); return u; };
  const register = async (data) => { const u = await buyerRegister(data); setBuyer(u); return u; };
  const logout = async () => { try { await buyerLogout(); } catch (err) { logError('Buyer logout', err); } setBuyer(null); };

  return (
    <BuyerAuthContext.Provider value={{ buyer, ready, login, register, logout, refresh }}>
      {children}
    </BuyerAuthContext.Provider>
  );
}

export function useBuyerAuth() {
  const ctx = useContext(BuyerAuthContext);
  if (!ctx) throw new Error('useBuyerAuth must be used within BuyerAuthProvider');
  return ctx;
}
